// extracted by mini-css-extract-plugin
module.exports = {"signInClass":"signin_signInClass__GPD_8"};